import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FiRefreshCw, FiShield } from 'react-icons/fi';
import { API_URL } from '../../Api/api';
import { getAuthToken } from '../../Api/authToken';
import './AdminPages.css';

const SecuritySettings = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [captchaEnabled, setCaptchaEnabled] = useState(false);

  const headers = () => ({ Authorization: `Bearer ${getAuthToken()}` });

  const loadSettings = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/admin/captcha-settings`, { headers: headers() });
      setCaptchaEnabled(!!res.data?.enabled);
    } catch (e) {
      toast.error(e.response?.data?.error || 'Failed to load security settings');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadSettings(); }, [loadSettings]);

  const saveCaptcha = async (enabled) => {
    const prev = captchaEnabled;
    setCaptchaEnabled(enabled);
    setSaving(true);
    try {
      const res = await axios.put(`${API_URL}/admin/captcha-settings`, { enabled }, { headers: headers() });
      setCaptchaEnabled(!!res.data?.enabled);
      toast.success(enabled ? 'CAPTCHA enabled for sign up' : 'CAPTCHA disabled for sign up');
    } catch (e) {
      setCaptchaEnabled(prev);
      toast.error(e.response?.data?.error || 'Failed to save CAPTCHA setting');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="admin-page">
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h1><FiShield style={{ marginRight: 8 }} />Security Settings</h1>
          <p>Manage sign-up protection and account security options</p>
        </div>
        <button type="button" className="btn-secondary" onClick={loadSettings} disabled={loading}>
          <FiRefreshCw /> Refresh
        </button>
      </div>

      <div className="admin-card">
        {loading ? (
          <div className="skeleton" style={{ height: 120, borderRadius: 8 }} />
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16 }}>
              <div>
                <h3 style={{ margin: '0 0 6px' }}>Sign Up CAPTCHA</h3>
                <p style={{ margin: 0, color: 'var(--admin-text-muted)', maxWidth: 560 }}>
                  When enabled, new users must enter a random letter-and-number CAPTCHA before creating an account.
                </p>
              </div>
              <label className="toggle-label" style={{ flexShrink: 0 }}>
                <span>{captchaEnabled ? 'Enabled' : 'Disabled'}</span>
                <input
                  type="checkbox"
                  checked={captchaEnabled}
                  disabled={saving}
                  onChange={(e) => saveCaptcha(e.target.checked)}
                />
                <div className="toggle-switch" />
              </label>
            </div>
            <p style={{ margin: 0, fontSize: '0.85rem', color: '#64748b' }}>
              Status: <strong>{captchaEnabled ? 'Enabled' : 'Disabled'}</strong>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SecuritySettings;
